import { ServiceUnavailableError } from '@api/Errors'
import ErrorHandler from '@api/ErrorHandler'

export default class ServiceUnavailableErrorHandler extends ErrorHandler {
  constructor(response) {
    // we would normally need to call super and throw the error message, but the current way
    // we want to handle this is to just hard direct to the redirectURL
    if (response) {
      response.json().then(responseBody => {
        if (responseBody.redirectURL) {
          window.location.href = responseBody.redirectURL
        }
      })
    }

    super(response)

    throw new ServiceUnavailableError('503 Service Unavailable', response)
  }
}
